import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { tenantSettingsService } from '../services/tenantSettingsService'

export type TenantProductType = 'pms' | 'ppt'
const DEV_OVERRIDE_KEY = 'clnicl_dev_product_type_override'

function getDevOverride(): TenantProductType | null {
  if (typeof window === 'undefined') return null
  if (!import.meta.env.DEV) return null
  const raw = window.localStorage.getItem(DEV_OVERRIDE_KEY)
  if (raw === 'ppt') return 'ppt'
  if (raw === 'pms') return 'pms'
  return null
}

export function getStoredTenantProductType(): TenantProductType {
  const devOverride = getDevOverride()
  if (devOverride) return devOverride
  if (typeof window === 'undefined') return 'pms'
  const raw = window.localStorage.getItem('tenant_product_type')
  return raw === 'ppt' ? 'ppt' : 'pms'
}

export function useTenantProductType() {
  const query = useQuery({
    queryKey: ['tenant-settings-product-type'],
    queryFn: () => tenantSettingsService.getCurrent(),
    staleTime: 60_000,
  })

  const apiProductType: TenantProductType = query.data?.productType === 'ppt' ? 'ppt' : 'pms'
  const productType = getDevOverride() || apiProductType
  const isPptOnly = productType === 'ppt'
  const isPms = productType === 'pms'

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('tenant_product_type', productType)
    }
  }, [productType])

  return {
    ...query,
    productType,
    isPptOnly,
    isPms,
  }
}
